module.exports = __webpack_public_path__ + "img/SketchPng831a8e0a95399591665aabebe8d529f6771dbd76461d2ab75f9f0ef59929c784.7240f833.png";